import { Stack, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import Time from '../util/Time';
import { useDeviceClass, ui } from '../util/responsive';

export function Clock() {
  const [time, setTime] = useState('');
  const d = useDeviceClass();

  useEffect(() => {
    const changeTime = () => {
      const nowTimeStrings = Time.Now().DateStrings();
      const nowTimeString = `${nowTimeStrings.year}/${nowTimeStrings.month2}/${nowTimeStrings.date2} (${nowTimeStrings.day}) ${nowTimeStrings.hour2}:${nowTimeStrings.minute2}:${nowTimeStrings.second2}`;
      setTime(nowTimeString);
    };
    changeTime();
    const timer = setInterval(changeTime, 1000);
    return () => clearInterval(timer);
  }, []);

  return(
    <Stack minWidth={ui.clock.width[d]} maxWidth={ui.clock.width[d]}>
      <Typography fontSize={ui.clock.font[d]} whiteSpace="nowrap">{time}</Typography>
    </Stack>
  )
}
